export const iconFontAwesomeCodingFile = (
	<i className="fa-solid fa-file"></i>
);
